const messages = {
  logout: 'Log Out',
  administrator: 'Administrator',
  help: 'T-E'
}

export default messages
